import { forwardRef } from 'react';

import { Box, Button, Container, IconButton, Typography } from '@mui/material';
import { CloseIcon } from '@truvhq/ui';
import { useMount } from 'react-use';

import { trackEvent } from 'shared/lib/analytics/trackEvent';

import { UpgradePromoEvent } from '../lib/constants';
import type { PlanPitch } from '../lib/tierPitch';

export type UpgradePromoBannerProps = {
  pitch: PlanPitch;
  onCta: () => void;
  onDismiss: () => void;
};

export const UpgradePromoBanner = forwardRef<HTMLDivElement, UpgradePromoBannerProps>(
  ({ pitch, onCta, onDismiss }, ref) => {
    useMount(() => {
      trackEvent(UpgradePromoEvent.SHOWN, { layout: 'banner', target_tier: pitch.targetTier });
    });

    return (
      <Box
        ref={ref}
        role="region"
        aria-label="Upgrade plan promotion"
        className="relative z-10 flex h-10 w-full items-center justify-center text-white"
        sx={{
          backgroundImage: 'linear-gradient(90deg, #224185 0%, #254a9e 15%, #203565 50%, #2855bb 70%, #223c79 100%)',
        }}
      >
        <Container disableGutters className="relative h-full px-4" maxWidth="xl">
          <div className="flex h-full w-full items-center justify-center gap-3">
            <Typography className="text-white opacity-90">{pitch.headline}</Typography>
            <Button onClick={onCta} variant="text" size="small" className="text-white underline hover:text-white/80">
              {pitch.ctaLabel}
            </Button>
          </div>
        </Container>
        <IconButton
          aria-label="Dismiss upgrade banner"
          size="small"
          sx={{
            position: 'absolute',
            right: 8,
            top: '50%',
            transform: 'translateY(-50%)',
            color: 'rgba(255,255,255,0.7)',
          }}
          onClick={onDismiss}
        >
          <CloseIcon />
        </IconButton>
      </Box>
    );
  },
);
UpgradePromoBanner.displayName = 'UpgradePromoBanner';
